import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';
import BSLAPopupItemComponent from '../../helpers/BSLAPopupItemComponent';

const BSLAPantherFocusAreaLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        url: 'https://utility.arcgis.com/usrsvcs/servers/914b7088ed7f40cda9ede01099ed4a1c/rest/services/PANTHER_FOCUS_AREA_V2/FeatureServer/0',
        visible: false,
        title: 'Panther Focus Area (USFWS)',
        popupTemplate: {
            outFields: ['*'],
            title: 'Panther Focus Area (USFWS)',
            content: (feature: __esri.Feature) => {
                const atts = feature.graphic.attributes;
                const node = document.createElement('div');
                const content = (
                    <React.Fragment>
                        <BSLAPopupItemComponent label="Zone" value={atts.ZONE} />
                        <BSLAPopupItemComponent label="Description" value={atts.DESCRIPT} />
                        <BSLAPopupItemComponent label="Source Agency" value={atts.SOURCE_AGENCY} />
                        <div className="mt-3 mb-1">
                            <p className="mb-1">
                                Issue: Impacts to State and Federally protected Florida Panther Habitat within the FWS Panther Focus Area may require surveys, lengthy permitting
                                time frames, and significant mitigation costs.
                            </p>
                            <p>
                                Cost: Development greater than 1 acre within the Panther Focus Area often require lengthy permitting time frames and face significant restrictions
                                to land use. Mitigation for habitat impacts is typically achieved by setting aside land on site, off site or through the purchase of mitigation
                                credits. Costs vary greatly based upon development size, land prices, and permitting complexity. Seek professional guidance from a reputable
                                environmental consultant before purchasing land in the Panther Focus Area.
                            </p>
                        </div>
                        <BSLAExternalLinkComponent href="http://myfwc.com/wildlifehabitats/managed/panther" />
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLAPantherFocusAreaLayer;
